import styled from 'styled-components';

export default styled.div`
  border-bottom: 2px solid ${(props) => props.theme.colors.grey};
  padding: 0 82px;
  padding-top: 33px;
  padding-bottom: 10px;

  .header-content {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    align-items: center;
    max-width: 1378px;
    width: 100%;
    margin: 0 auto;
    .left {
      display: flex;
      flex-direction: row;
      .help {
        top: -4px;
        position: relative;
        padding-left: 10px;
      }
    }
  }

  .middle {
    display: flex;
    flex-direction: column;

    &,
    & > * {
      white-space: nowrap;
      display: flex;
      align-items: center;
    }

    .round {
      margin-right: 22px;
      font-size: 14px;

      &-container {
        margin-top: 10px;
      }
    }
  }

  .name {
    font-size: 24px;
    font-weight: bold;
  }

  .right {
    min-height: 74px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding-left: 50px;

    & > div {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
    }

    .time {
      color: ${(props) => props.theme.colors.primary};
      font-size: 36px;
      font-weight: bold;
    }

    .overtime {
      color: ${(props) => props.theme.colors.error};
    }

    .pause {
      margin-bottom: 6px;
    }

    .change-status {
      padding-bottom: 23px;
    }
  }

  .dropdown-container {
    position: relative;
    display: flex;
    justify-content: center;

    .inner {
      position: absolute;
      width: 160px;
      text-align: center;
    }
  }
`;

export const StyledResultInput = styled.div`
  height: 24px;
  width: 69px;
  display: grid;
  grid-gap: 5px;
  align-items: center;
  grid-template-columns: auto auto;
`;
